module.exports = __webpack_public_path__ + "img/icon_vcard_white.731d5e2.svg";